import React, { useContext } from 'react';
import { Box, SxProps, Typography, useTheme } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';
import type { Variant } from '@mui/material/styles/createTypography';
import { TypographyPropsVariantOverrides } from '@mui/material';
import { nbsp } from 'shared/lib/utils/uiConstants';

export default function SearchWrapper({
  children,
  sx,
  text = `Найти${nbsp}любой${nbsp}документ Вы${nbsp}сможете${nbsp}в${nbsp}базе${nbsp}знаний`,
  textVariant = 'f24b',
}: {
  children: React.ReactNode;
  sx?: SxProps;
  text?: string;
  textVariant?: keyof TypographyPropsVariantOverrides | Variant;
}) {
  const theme = useTheme();

  const {
    spacings: { sp, general },
  } = useContext(UiContext);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 1,
        height: 1,
        maxWidth: general.maxBlockWidth,
        gap: {
          mobile: 4,
          tablet: 6,
          laptop: sp.s50,
        },
        ...sx,
      }}
    >
      <Typography
        sx={{ textAlign: 'center', opacity: 0, pointerEvents: 'none' }}
        variant={textVariant}
        color={theme.palette.primary.contrastText}
      >
        {text}
      </Typography>
      {children}
    </Box>
  );
}
